import { t } from 'i18next'
import { useState } from 'react'

import icons from '../../assets/BuildIcons/Icons'
import CancelIcon from '../../assets/CancelIcon.svg'
import FilterIcon from '../../assets/FilterIcon.svg'
import pageLanguage from '../../functions/pageLanguage'
import RefinedBrands from '../Brands/RefinedBrands'
import Colors from '../Colors/Colors'
import MobileClearRefinements from '../CurrentRefinement/MobileClearRefinements'
import Price from '../Price/Price'
import './MobileFilter.scss'


const MobileFilter = () => {
  const win = window
  const [filter, setFilter] = useState(false)
  const localhost = win.location.hostname === 'localhost'
  const lang = pageLanguage()
  const brandAttribute = lang === "ar" ? "category.brand.valueAr" : "category.brand.valueEn"
  const colorTextAttribute = "category.colorCode.filter"

  return (
    <div className="mobileFilter">
      {filter && <div className="mobileFilter_backDrop" />}
      <div>
        <button
          className="sortButton"
          style={{ border: 'none', backgroundColor: 'white' }}
          onClick={() => setFilter(!filter)}
        >
          <div className="mobileFilterLabel">
            <span>
              <img
                src={localhost ? FilterIcon : icons.filterIcon}
                alt="filterIcon"
              />
            </span>
            <span>{t('filter')}</span>
          </div>
        </button>
      </div>
      <div
        className="mobileFilterOptions"
        style={{ display: filter ? 'block' : 'none' }}
      >
        <>
          <div className="mobileFilterTitle">{t('filter')}</div>
          <div
            className="filterCancel"
            onClick={() => {
              setFilter(false)
            }}
          >
            <img
              src={localhost ? CancelIcon : icons.cancelIcon}
              alt="cancelIcon"
            />
          </div>
        </>
        <Price />
        <RefinedBrands attribute={brandAttribute} />
        <Colors attribute={colorTextAttribute}/>
        <div className="filterBtns">
          <MobileClearRefinements />
          <button className="mobileApplyBtn">
            <span
              className="mobileApplyBtnText"
              onClick={() => {
                setFilter(false)
              }}
            >
              {t('apply_filters')}
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default MobileFilter
